import { Copy, Check, ExternalLink, DollarSign } from 'lucide-react';
import OrderCountdown from '@/components/OrderCountdown';

export default function OrderCard({ order, copiedCode, onCopy, onExpire }) {
  const statusClass =
    order.status === 'paid'
      ? 'bg-green-100 text-green-800'
      : order.status === 'pending'
      ? 'bg-yellow-100 text-yellow-800'
      : order.status === 'expired'
      ? 'bg-gray-100 text-gray-800'
      : 'bg-red-100 text-red-800';

  return (
    <div
      className="bg-white rounded-xl p-6 border border-gray-200 hover:shadow-md transition-all"
      data-testid={`order-card-${order.order_code}`}
    >
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-2">
            <code className="text-lg font-bold" style={{ color: '#003594' }}>
              {order.order_code}
            </code>
            <span className={`px-3 py-1 text-xs font-medium rounded-full ${statusClass}`}>
              {order.status}
            </span>
            {order.payee_wallets?.length > 0 && (
              <span className="px-3 py-1 text-xs font-medium bg-blue-100 text-blue-800 rounded-full">
                Dispersión: {order.payee_wallets.length} wallets
              </span>
            )}
          </div>
          <p className="text-gray-600 mb-1">{order.description}</p>
        </div>
        <div className="text-right">
          <p className="text-2xl font-bold" style={{ color: '#051C2C' }}>
            {order.currency} {order.amount.toFixed(2)}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
        <Field label="Cliente" value={order.payer_name} />
        <Field label="Email" value={order.payer_email} />
        <Field label="Referencia" value={order.order_reference} mono />
        <div>
          <p className="text-xs text-gray-600 mb-1">Expira</p>
          <div className="flex flex-col gap-1">
            <p className="text-sm font-medium">
              {new Date(order.expires_at).toLocaleString('es-VE', {
                timeZone: 'America/Caracas',
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
              })}
            </p>
            <OrderCountdown
              expiresAt={order.expires_at}
              status={order.status}
              orderId={order.order_id}
              onExpire={onExpire}
            />
          </div>
        </div>
      </div>

      <div className="flex gap-2 pt-4 border-t border-gray-200">
        <button
          onClick={() => onCopy(order.payment_url, order.order_code)}
          data-testid={`copy-link-${order.order_code}`}
          className="flex items-center gap-2 px-4 py-2 text-sm rounded-lg transition-colors"
          style={{ backgroundColor: '#E8F3FA', color: '#003594' }}
        >
          {copiedCode === order.order_code ? (
            <>
              <Check className="w-4 h-4" />
              Copiado
            </>
          ) : (
            <>
              <Copy className="w-4 h-4" />
              Copiar Link
            </>
          )}
        </button>
        <a
          href={order.payment_url}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 px-4 py-2 text-sm border border-gray-300 rounded-lg hover:bg-gray-50"
        >
          <ExternalLink className="w-4 h-4" />
          Abrir Pasarela
        </a>
        {order.payee_wallets?.length > 0 && (
          <span className="ml-auto text-xs text-gray-600 flex items-center gap-1">
            <DollarSign className="w-3 h-3" />
            {order.payee_wallets.length} beneficiarios configurados
          </span>
        )}
      </div>
    </div>
  );
}

function Field({ label, value, mono }) {
  return (
    <div>
      <p className="text-xs text-gray-600 mb-1">{label}</p>
      <p className={`text-sm font-medium ${mono ? 'font-mono' : ''}`}>{value}</p>
    </div>
  );
}
